'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};



// styles
var _react = require('react');var _react2 = _interopRequireDefault(_react);var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);var _components = require('../../components');var _FaqList = require('./FaqList.scss');var styles = _interopRequireWildcard(_FaqList);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var FaqList = function FaqList(props) {
  var renderItem = function renderItem(data) {return (
      _react2.default.createElement(_components.FaqItem, _extends({}, data, { locale: props.locale })));};


  return (
    _react2.default.createElement('div', { className: styles.listWrapper },
      _react2.default.createElement('div', { className: styles.title },
        _react2.default.createElement('span', { className: 'icon icon-faq' },
          _react2.default.createElement('span', { className: 'path1' }),
          _react2.default.createElement('span', { className: 'path2' }),
          _react2.default.createElement('span', { className: 'path3' }),
          _react2.default.createElement('span', { className: 'path4' }),
          _react2.default.createElement('span', { className: 'path5' }),
          _react2.default.createElement('span', { className: 'path6' })), '\xA0\xA0',


        _react2.default.createElement('span', null, props.title)),

      _react2.default.createElement('div', null,
        props.questions.map(renderItem))));



};

FaqList.propTypes = {
  questions: _propTypes2.default.array,
  locale: _propTypes2.default.string,
  title: _propTypes2.default.string };exports.default =


FaqList;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FAQList/FAQList.js
// module id = 2666
// module chunks = 0